<template>
  <div>
    <span class="caption font-weight-bold">
      Responsáveis
      <px-responsaveis-dialog :custom-path="customPath"
                              :id="id"
                              :responsaveis="responsaveis"
                              @update="onUpdate">
        <template v-slot:activator="{ on }">
          <v-btn class="ml-1" color="primary" x-small text v-on="on">
            Alterar
          </v-btn>
        </template>
      </px-responsaveis-dialog>
    </span>
    <div>
      {{ description }}
    </div>
  </div>
</template>

<script>
import { isEmpty, first } from 'lodash';
import PxResponsaveisDialog from './PxResponsaveisDialog.vue';

export default {
  props: {
    responsaveis: Array,
    id: {
      type: [String, Number],
      required: true,
    },
    customPath: {
      type: String,
      required: true,
    },
  },
  computed: {
    description() {
      if (isEmpty(this.responsaveis)) {
        return 'Sem responsável';
      }
      const text = first(this.responsaveis.map((a) => a.nome));
      if (this.responsaveis.length > 1) {
        return `${text} (+${this.responsaveis.length - 1})`;
      }
      return text;
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
  },
  components: {
    PxResponsaveisDialog,
  },
};
</script>
